import { action } from 'easy-peasy';
import { IActionRemoveCarePlanHospitalization } from '../types';

const removeCarePlanHospitalization: IActionRemoveCarePlanHospitalization = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanHospitalization;
